<template>
  <div class="register absolute" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.dl_span5')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 0.8rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;">
          <img
            src="../../assets/images/img/img/logo.png"
            style="border-radius:15px;"
            alt=""
          />
        </div>
        {{ $t("m.dl_span05") }}
      </div>
    </div>
    <div class="register_block">
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user1.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        +<input style="width: 34px;" type="text" v-model="value" />
        <country-code-selector
          style="background-color:#fff;"
          :countryCode.sync="value"
        ></country-code-selector>
        <input
          v-model="account"
          type="tel"
          maxlength="11"
          @input="onPhoneInput"
          :placeholder="$t('m.dl_span2')"
          style="padding-left:10px;"
        />
      </div>
      <div class="register_code">
        <div class="register_code_list" style="flex:1;">
          <!-- <img
            src="../../assets/images/user3.png"
            style="width: 16px;height: 16px;margin-right:18px"
            alt=""
          /> -->
          <input
            style="width: 140px;"
            v-model="codeVal"
            :placeholder="$t('m.dl_span8')"
          />
        </div>
        <div class="register_code_lists">
          <p class="" @click="code">{{ codeBtnTit }}</p>
        </div>
      </div>
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user2.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        <input v-model="password" :placeholder="$t('m.dl_span3')" />
      </div>
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user2.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        <input v-model="password2" :placeholder="$t('m.dl_span18')" />
      </div>
      <van-button class="register_submit" @click="registerReset">{{
        $t("m.tijiao")
      }}</van-button>
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { registerVerify, registerReset, getCodeApi } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import { required, alpha_num } from "@utils/validate";
import { VUE_APP_API_URL } from "@utils";
import countryCodeSelector from "@components/CodeSelector/components/index";
export default {
  components: {
    countryCodeSelector
  },
  name: "RetrievePassword",
  data: function() {
    return {
      value: 86,
      show: false,
      disabled: false,
      alltime: 60,
      codeBtnTit: this.$t("m.dl_span9"),
      account: "",
      password: "",
      password2: "",
      captcha: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false
    };
  },
  mixins: [sendVerifyCode],
  mounted: function() {
    // this.getCode();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
      if (window.localStorage.getItem("quhao")) {
        this.value = window.localStorage.getItem("quhao");
      }
      this.codeBtnTit = this.$t("m.dl_span9");
    },
    onPhoneInput() {
      this.account = String(this.account || "")
        .replace(/\D/g, "")
        .slice(0, 11);
    },
    sendCode() {
      //倒计时
      let alltime = this.alltime;
      if (alltime == 0) {
        this.alltime = 60;
        this.codeBtnTit = this.$t("m.dl_span9");
        this.disabled = false;
        return;
      } else {
        alltime--;
        this.codeBtnTit = this.$t("m.dl_span13") + alltime;
        this.alltime = alltime;
        this.disabled = true;
      }
      let that = this;
      setTimeout(function() {
        that.sendCode();
      }, 1000);
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
      console.log(this.codeUrl);
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.fromError(res, "操作失败，请稍后重试");
        });
    },
    async registerReset() {
      var that = this;
      const { account, password, codeVal, password2 } = that;
      console.log(password2);
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码"))],
            codeVal: [required(required.message("验证码"))],
            password: [
              required(required.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ],
            password2: [required(required.message("密码"))],
            captcha: this.isShowCode ? [required(required.message("密码"))] : []
          })
          .validate({ account, password, codeVal, password2 });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (password != password2) {
        that.$dialog.message("两次密码不一致");
        return;
      }
      const area = String(this.value || "").replace(/\D/g, "");
      const phone = String(account || "").replace(/\D/g, "");
      if (area === "86" && !/^1\d{10}$/.test(phone)) {
        return this.$dialog.error("请填写11位手机号码");
      }
      if (area !== "86" && !/^\d{6,15}$/.test(phone)) {
        return this.$dialog.error("请填写正确的手机号码");
      }
      this.show = true;
      registerReset({
        area: this.value,
        mobile: that.value + that.account,
        password: that.password,
        sms: that.codeVal
      })
        .then(res => {
          this.show = false;
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          this.show = false;
          this.$dialog.fromError(res, "操作失败，请稍后重试");
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码"))]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (this.disabled == true) {
        return;
      }
      that.sendCode();
      registerVerify({
        area: this.value,
        mobile2: that.account,
        mobile: that.value + that.account
      })
        .then(res => {
          console.log("离开家地方");
          that.$dialog.success(res.msg);
          // that.sendCode();
        })
        .catch(res => {
          console.log("离开家地方2");
          console.log(res);
          // if (res.data.status === 402) {
          //   that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
          //   that.isShowCode = true;
          // }
          this.$dialog.fromError(res, "操作失败，请稍后重试");
        });
    }
  }
};
</script>
<style scoped lang="less">
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 80px;
    height: 80px;
  }
}
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
  margin-top: 20px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
.register_block_list input {
  line-height: 50px;
  height: 50px;
  font-size: 15px;
}
.register_block_list input[type="tel"] {
  flex: 1;
  min-width: 0;
}
.register_code_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}
.register_code_lists {
  background: var(--bg-color);
  color: #ffffff;
  border-radius: 20px;
  height: 32px;
  margin-left: 0px;
  padding: 0 15px;
  line-height: 32px;
  font-weight: bold;
  font-size: 13px;
}
.register_code_list {
  width: 100%;
  height: 50px;

  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
/deep/ .flag-list-box {
  background: #fff;
}
/deep/ .flag.flag-cf {
  display: none;
}
/deep/ .flag {
  display: none;
}
/deep/ .country-name {
  display: none;
}
/deep/ .area-codeNum {
  display: none !important;
}
/deep/ .intl-tel-input-container {
  padding-left: 3px !important;
  border-right: 1px solid #eee !important;
}
</style>
